import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";// import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import EnhancedTextField from "src/components/enhanced/EnhancedTextField";
import { createCustomer, fetchFilteredCustomers } from "src/features/modalEditSlice";
import alertHelper from "src/helpers/alertHelper";
import { getSessionCheckedCompany } from "src/helpers/sessionHelper";

const filter = createFilterOptions();

export default function AutoCompInputCustomer(props) {
  const dispatch = useDispatch();
  const filteredCustomersList = useSelector((state) => state.modalEdit.filteredCustomersList);

  const { value, setFormState } = props;

  const [stateValue, setValue] = useState(value?.name || "");
  const [open, toggleOpen] = useState(false);
  const [dialogValue, setDialogValue] = useState({
    firstName: "",
    lastName: "",
    phone: ""
  });

  useEffect(() => {
    setValue(value?.name ?? `${value?.fullName ?? ""}${value?.phone ? ` ${value?.phone}` : ""}`);
  }, [value]);

  function handleClose() {
    setDialogValue({
      firstName: "",
      lastName: "",
      phone: ""
    });
    toggleOpen(false);
  }

  function handleSubmit(event) {
    event.preventDefault();

    // phone validation
    const re = /^[0-9\b]+$/;
    if (!re.test(dialogValue.phone)) {
      alertHelper.error({ message: "Telefoní číslo musí být číslo." });
      return false;
    }

    dispatch(
      createCustomer({
        firstName: dialogValue.firstName,
        lastName: dialogValue.lastName,
        phone: dialogValue.phone,
        companyId: getSessionCheckedCompany()
      })
    );
    handleClose();
  }

  function handleAutoCompChange(event, newValue) {
    if (typeof newValue === "string") {
      // timeout to avoid instant validation of the dialog's form.
      setTimeout(() => {
        toggleOpen(true);
        setDialogValue({
          firstName: "",
          lastName: newValue,
          phone: ""
        });
      });
    } else if (newValue && newValue.inputValue) {
      toggleOpen(true);
      setDialogValue({
        firstName: "",
        lastName: newValue.inputValue,
        phone: ""
      });
    } else {
      handleCustomerChange(newValue);
      setValue(newValue);
    }
  }

  function handleCustomerChange(customer) {
    setFormState((formState) => ({
      ...formState,
      customer: customer
    }));

    if (customer) {
      setFormState((formState) => ({
        ...formState,
        title: `${formState.title} ${customer?.fullName}`
      }));
    }
  }

  function getAutoCompFilterOpts(options, params) {
    const filtered = filter(options, params);
    if (params.inputValue !== "" && params.inputValue.length >= 3) {
      dialogValue.firstName !== params.inputValue &&
        setTimeout(() => {
          setDialogValue((prevState) => {
            dispatch(fetchFilteredCustomers(params.inputValue));
            return { ...dialogValue, firstName: params.inputValue };
          });
        });

      filtered.push({
        inputValue: params.inputValue,
        fullName: `Přidat "${params.inputValue}"`
      });
    }
    return filtered;
  }

  function getAutoCompOptLabel(option) {
    // e.g value selected with enter, right from the input
    if (typeof option === "string") {
      return option;
    }
    if (option.inputValue) {
      return option.inputValue;
    }
    return `${option.fullName}${option.phone ? ` ${option.phone}` : ""}`;
  }

  const handleChange = (e) => {
    e.persist();
    setDialogValue((dialogValue) => ({
      ...dialogValue,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <React.Fragment>
      <Autocomplete
        value={stateValue}
        onChange={(event, newValue) => handleAutoCompChange(event, newValue)}
        filterOptions={(options, params) => getAutoCompFilterOpts(options, params)}
        id="free-solo-dialog-demo"
        options={filteredCustomersList}
        getOptionLabel={(option) => getAutoCompOptLabel(option)}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        renderOption={(option) => `${option.fullName}${option.phone ? ` ${option.phone}` : ""}`}
        style={{ width: "100%" }}
        freeSolo
        renderInput={(params) => <TextField required {...params} label="Zákazník" variant="outlined" />}
      />
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <form onSubmit={handleSubmit}>
          <DialogTitle id="form-dialog-title">Přidat nový</DialogTitle>
          <DialogContent>
            <DialogContentText>Přidat nového zákazníka</DialogContentText>
            <EnhancedTextField
              name="lastName"
              value={dialogValue.lastName}
              label="Příjmení"
              onChange={handleChange}
              margin="dense"
            />
            <EnhancedTextField
              name="firstName"
              value={dialogValue.firstName}
              label="Jméno"
              onChange={handleChange}
              margin="dense"
            />
            <EnhancedTextField
              name="phone"
              value={dialogValue.phone}
              label="Telefon"
              onChange={handleChange}
              margin="dense"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Zavřít
            </Button>
            <Button type="submit" color="primary">
              Přidat
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}

AutoCompInputCustomer.propTypes = {
  filteredCustomersList: PropTypes.array
};

AutoCompInputCustomer.defaultProps = {
  filteredCustomersList: []
};
